import Http from '../utils/http';
import LocalStorage from '../utils/localStorage';

const http = new Http(`${process.env.URL_BASE}`);
const usuarioLogado = LocalStorage.obter('usuario') || {};
http.setarTokenDeAutenticacao(usuarioLogado.tokenDeAutorizacaoDoKeycloak);

const metodos = {
  get: (path, params = {}, headers = {}) => http.get(path, params, headers),
  getArraybuffer: path => http.getArraybuffer(path),
  post: (path, body = {}, headers = {}) => http.post(path, body, headers),
  put: (path, body = {}, headers = {}) => http.put(path, body, headers),
  delete: (path, body = {}, headers = {}) => http.delete(path, body, headers),
};

/* eslint-disable no-param-reassign, no-unused-vars */
const plugin = {
  install(Vue, options) {
    Vue.prototype.$api = metodos;
  },
};

export default plugin;


// WEBPACK FOOTER //
// ./src/plugins/api.js